module.exports = __webpack_public_path__ + "img/134.3a0fa973.jpg";